import { Modal, ActionButton, TextField, Field, Text } from "components/commons";
import locale from "localization";
import React, { useState } from "react";
import styles from "./declare-receipt-issuance-modal.scss";

const MIN_LENGTH = 5;
const MAX_LENGTH = 20;

const DeclareReceiptIssuanceModal = ({ close, active, onConfirm }) => {
  const [orNumber, setOrNumber] = useState("");
  const [touched, setTouched] = useState(false);

  const isValid = orNumber.length >= MIN_LENGTH && orNumber.length <= MAX_LENGTH;
  const showMinError = touched && orNumber.length > 0 && orNumber.length < MIN_LENGTH;

  const handleClose = () => {
    setOrNumber("");
    setTouched(false);
    close();
  };

  const handleConfirm = () => {
    if (isValid) {
      onConfirm({ orNumber });
      setOrNumber("");
      setTouched(false);
    }
  };

  const handleChange = (name, { value }) => {
    const alphanumeric = value.replace(/[^a-zA-Z0-9]/g, "");
    setOrNumber(alphanumeric);
    setTouched(true);
  };

  return (
    <Modal
      active={active}
      title={locale.declareReceiptIssuance}
      close={handleClose}
      className={styles.modal}
    >
      <div className={styles.content}>
        <Text className={styles.description}>{locale.youAreDeclaringReceiptIssuance}</Text>
        <Field
          label={locale.orNumber}
          labelPosition="left"
          childrenStyle={{ width: "300px" }}
          style={{ display: "flex", alignItems: "center" }}
          message={showMinError ? locale.populate(locale.minimumNCharacters, [MIN_LENGTH]) : null}
          error={showMinError}
        >
          <TextField
            name="orNumber"
            value={orNumber}
            onChange={handleChange}
            inputProps={{ maxLength: MAX_LENGTH }}
          />
        </Field>
      </div>
      <ActionButton
        right
        items={[
          {
            text: locale.cancel,
            onClick: handleClose,
          },
          {
            text: locale.confirm,
            onClick: handleConfirm,
            disabled: !isValid,
          },
        ]}
      />
    </Modal>
  );
};

export default DeclareReceiptIssuanceModal;
